import Vue from 'vue';

import ModalPlugin from './core';

Vue.use(ModalPlugin);
